import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import SEO from '../components/SEO';
import { carpetTypes } from '../data/mock';
import { Info } from 'lucide-react';

const CarpetTypes = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO 
        title="Yıkanan Halı Türleri"
        description="Makine halısı, shaggy, bambu, viskon, akrilik, kilim, el dokuma, yün, Hereke, İran, ipek halı ve daha fazlası. Tüm halı türleri için profesyonel yıkama."
        keywords="makine halısı yıkama, shaggy halı yıkama, hereke halısı yıkama, iran halısı yıkama, ipek halı yıkama, kilim yıkama, el dokuma halı yıkama"
        canonical="https://www.bahcesehirduruhaliyikama.com/hali-turleri"
      />
      {/* Header */}
      <section className="bg-gradient-to-br from-teal-600 to-cyan-600 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-4">Halı Türleri</h1>
          <p className="text-xl text-teal-50 max-w-3xl mx-auto">
            Her türlü halı için özel bakım ve yıkama teknikleri uyguluyoruz. 
            Halılarınızın yapısına uygun profesyonel temizlik garantisi.
          </p>
        </div>
      </section>

      {/* Carpet Types Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {carpetTypes.map((carpet) => (
              <Card key={carpet.id} className="overflow-hidden group hover:shadow-2xl transition-all border-2 hover:border-teal-500">
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={carpet.image}
                    alt={carpet.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-gray-900/40 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <h3 className="text-2xl font-bold text-white mb-1">{carpet.name}</h3>
                  </div>
                </div>
                <CardContent className="p-6">
                  <p className="text-gray-700 mb-4 leading-relaxed">{carpet.description}</p>
                  <div className="bg-teal-50 p-4 rounded-lg border-l-4 border-teal-600">
                    <div className="flex items-start gap-2">
                      <Info className="w-5 h-5 text-teal-600 mt-0.5 flex-shrink-0" />
                      <div>
                        <p className="text-sm font-semibold text-gray-900 mb-1">Bakım Bilgisi:</p>
                        <p className="text-sm text-gray-700">{carpet.care}</p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Halı Yıkama Hakkında Bilmeniz Gerekenler</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <Card className="p-6 border-2 border-teal-100">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Ne Sıklıkla Yıkatmalı?</h3>
                <p className="text-gray-700 leading-relaxed">
                  Halılarınızı yılda en az 1-2 kez profesyonel olarak yıkatmanız önerilir. 
                  Yoğun kullanılan alanlarda bu süre daha kısa olabilir.
                </p>
              </Card>
              <Card className="p-6 border-2 border-teal-100">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Neden Profesyonel Yıkama?</h3>
                <p className="text-gray-700 leading-relaxed">
                  Evde yapılan temizlik yüzeyseldir. Profesyonel yıkama ile halının derinindeki 
                  kir, toz ve bakteriler tamamen temizlenir.
                </p>
              </Card>
              <Card className="p-6 border-2 border-teal-100">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Kuruma Süresi</h3>
                <p className="text-gray-700 leading-relaxed">
                  Modern ekipmanlarımız sayesinde halılarınız doğal hava ile kurutulur. 
                  Mevsim şartlarına göre 1-2 gün içinde tamamen kurur.
                </p>
              </Card>
              <Card className="p-6 border-2 border-teal-100">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Renk Güvenliği</h3>
                <p className="text-gray-700 leading-relaxed">
                  Özel deterjanlarımız ve yıkama tekniklerimiz ile halılarınızın renkleri 
                  koruma altındadır. Renk solması yaşanmaz.
                </p>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CarpetTypes;
